const init = () => {
  const links = document.querySelectorAll('a[data-content-source]');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      const contentSource = this.getAttribute('data-content-source');
      if (contentSource) {
        try {
          sessionStorage.setItem('content_source', contentSource);
          if (!sessionStorage.getItem('entry_source')) {
            sessionStorage.setItem('entry_source', contentSource);
          }
        } catch (e) {
          console.error('[ContentSource] Failed to save (Private Mode?):', e);
        }
      }
    });
  });
};

export default { init };
